/**
 * Tabs JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Tabs
 */
class Tabs {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.tabs = $( '.js-tab' );
        this.tabTargets =  $( '.js-tabtarget' );
    }

    /**
     * All events of the class.
     * @return {void}
     */
    events() {

        // Loop through tabs and bind a click handler to each of them.
        this.tabs.each( ( index, tab ) => {

            $( tab ).on( 'click', ( e ) =>  {

                // Remove the active class from other tabs.
                // Add an active class to the tab
                // and call the section showing method with the anchor ID.
                this.tabs.removeClass( 'js-active' );
                tab.classList.toggle( 'js-active' );
                this.showTabbedSection( e, tab.dataset.anchorLink );

            });

        });
    }

    /**
     * This shows the corresponding text container on tab link clicks.
     *
     * @param {event} e
     * @param {string} anchorLink The anchor ID passed from the clicked tab.
     */
    showTabbedSection( e, anchorLink ) {

        // Stop the event with the static method from the Common class.
        Theme.Common.stop( e );

        // Hide all containers first.
        this.tabTargets.addClass( 'js-hidden' );

        // Then loop through them and show only the one that has the anchor target
        // ID as the one passed from the clicked tab.
        this.tabTargets.each( ( index, textcontainer ) => {

            if ( anchorLink === textcontainer.dataset.anchorTarget ) {
                textcontainer.classList.remove( 'js-hidden' );
            }

        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = Tabs;



// WEBPACK FOOTER //
// ./assets/scripts/tabs.js